import { IOperation } from '@/contracts/system-modules/sync/operation/IOperation'
import { IRecordState } from '@/contracts/system-modules/sync/operation/IRecordState'
import { EnumOperationKind } from '@/contracts/system-modules/sync/enum/EnumOperationKind'
import { isLaterTime } from '@/helpers/operationTime'

export function emptyRecordState(record: string): IRecordState {
  return { record, fields: {}, times: {}, isRemoved: false }
}

/**
 * Слияние операции с состоянием записи — те же правила, что на узлах:
 * удаление окончательно; иначе по каждому полю побеждает большая метка.
 * Итог не зависит от порядка операций; исходное состояние не меняется.
 */
export function mergeRecord(state: IRecordState, operation: IOperation): IRecordState {
  if (state.isRemoved) {
    return state
  }
  if (operation.kind === EnumOperationKind.REMOVE) {
    return { ...state, isRemoved: true }
  }

  const fields = { ...state.fields }
  const times = { ...state.times }
  Object.keys(operation.fields).forEach((field) => {
    if (isLaterTime(operation.time, times[field])) {
      fields[field] = operation.fields[field]
      times[field] = operation.time
    }
  })

  return { ...state, fields, times }
}
